var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-stamp",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"demo-stamp__label"},[_vm._v(_vm._s(_vm.$t('demoTitle')))])])}
var staticRenderFns = []

export { render, staticRenderFns }